import { svgCursorStyle } from './svgCursorStyle';

const PLUS_SVG = [
    '<svg xmlns="http://www.w3.org/2000/svg"',
    ' width="16" height="16" viewBox="0 0 16 16">',
    '<line x1="8" y1="0" x2="8" y2="16"',
    ' stroke="white" stroke-width="2"/>',
    '<line x1="0" y1="8" x2="16" y2="8"',
    ' stroke="white" stroke-width="2"/>',
    '</svg>',
].join('');

const MINUS_SVG = [
    '<svg xmlns="http://www.w3.org/2000/svg"',
    ' width="16" height="16" viewBox="0 0 16 16">',
    '<path stroke="#fff" stroke-width="2"',
    ' d="M10 16h6M8 0v16M0 8h16"/>',
    '</svg>',
].join('');

const PLUS_CURSOR = svgCursorStyle(PLUS_SVG, { x: 8, y: 8 }, 'crosshair');
const MINUS_CURSOR = svgCursorStyle(MINUS_SVG, { x: 8, y: 8 }, 'crosshair');

/** Crosshair cursor for drawing contours: a plus, or a minus when erasing. */
export function targetCrosshairCursor(erase: boolean): string {
    return erase ? MINUS_CURSOR : PLUS_CURSOR;
}
